export default __webpack_public_path__ + "static/media/coswork-poster.1bf2b979.png";